import { formatDate } from '@angular/common';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { QuestionHelpText } from 'src/app/model/question-help-text';
import { HelpTextDialogService } from 'src/app/service/help-text-dialog.service';
import { QuestionHelpTextService } from 'src/app/service/question-help-text.service';

@Component({
  selector: 'app-question-help-text',
  templateUrl: './question-help-text.component.html',
  styleUrl: './question-help-text.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class QuestionHelpTextComponent implements OnInit  {
  questionIds: number[] = [];


    constructor(
      public dialogRef: MatDialogRef<QuestionHelpTextComponent>, 
      @Inject(MAT_DIALOG_DATA) public data: QuestionHelpText
    ) {
        console.log("questionHelpText called with data:")
        console.log(data)
    }

    ngOnInit(): void {

    }

    onNoClick(): void {
        this.dialogRef.close();
    }



    

}
